export default function ModalConfirm({ 
    visible, 
    title,
    url, 
    onConfirm, 
    onCancel, 
    onClose 
}) {
    if (!visible) return null;
    return (
        <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show d-block" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{title}</h5>
                            <button
                                type="button"
                                className="btn-close-modal"
                                aria-label="Cerrar"
                                onClick={onClose}
                            >
                                x
                            </button>
                        </div>
                        {url && (
                            <div className="modal-body">
                                <a 
                                    href={url} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                    Ver política de privacidad
                                </a>
                            </div>
                        )}
                        <div className="modal-footer d-flex justify-content-center">
                            <button
                                type="button"
                                className="btn-primary me-3"
                                onClick={onConfirm}
                            >
                                Sí
                            </button>
                            <button
                                type="button"
                                className="btn-secondary"
                                onClick={onCancel}
                            >
                                No
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
